export function isHeroSectionEmpty(props) {
    return !props.title || !props.subtitle || !props.offerDescription;
}
